<template>
    <div>
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">

        <div class="menu-list">
            <div class="menu-item">
                <img src="../assets/qa_icon.png" @click="_goto('qa')">
                <p> အေမးအေျဖ</p>
            </div>
            <div class="menu-item">
                <img src="../assets/store_icon.png" @click="_goto('doc')">
                <p>လုိက္နာရမည့္စည္းကမ္းမ်ား</p>
            </div>
            <div class="menu-item">
                <img src="../assets/info_icon.png" @click="_goto('info')">
                <p>အသံုးျပဳသူ သတင္းအခ်က္အလက္</p>
            </div>
            <div class="menu-item">
                <img src="../assets/unsub_icon.png" @click="_goto('unsub')">
                <p>အေကာင့္မွျပန္ထြက္ရန္</p>
            </div>
            <div class="menu-item">
                <img src="../assets/rule_icon.png" @click="_goto('rule')">
                <p>ေျဖဆုိရန္စည္းကမ္းမ်ား</p>
            </div>
        </div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Menu',
    components: {answerHeader},
    data(){
        return {
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        
    },
    methods: {
        _goto(target){
            this.$router.push(target);
        }
    }
}
</script>

<style lang="scss" scoped>
    .menu-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-around;
        left: 0;
        top: rem(300);
        bottom: 0;
        width: 100%;
        height: rem(800);
        .menu-item{
            flex: 0 0 50%;
            text-align: center;
            img{
                display: inline-block;
                width: rem(160);
                height: rem(160);
                border-radius: 50%;
            }
        }
    }
</style>










// WEBPACK FOOTER //
// src/components/Menu.vue